export default function ErrorBanner({ message, onDismiss }) {
  if (!message) return null;

  return (
    <div
      // Announced when it appears, because most of these arrive after an
      // action rather than on load, and the clinic is looking at the control
      // it just used rather than at the banner.
      role="alert"
      className="border border-red-200 bg-red-50 text-red-700 rounded-lg px-3 py-2 text-sm flex items-start justify-between gap-3"
    >
      <div>{message}</div>
      {onDismiss && (
        <button
          type="button"
          className="text-red-700/70 hover:text-red-900 text-xs"
          onClick={onDismiss}
        >
          Dismiss
        </button>
      )}
    </div>
  );
}
